// Paleta categórica dos gráficos: 8 cores em ORDEM FIXA (a ordem é o que garante distinção
// para daltônicos), com tons próprios para o tema escuro. Validada com o
// validate_palette.js contra as superfícies do app (#ffffff e #171c24): todas as checagens
// passam; no claro, aqua, amarelo e magenta ficam abaixo de 3:1 de contraste — por isso a
// legenda com valor fica sempre visível e existe a visão em tabela.

export const SERIES_LIGHT = ["#2a78d6", "#eb6834", "#1baf7a", "#eda100", "#e87ba4", "#008300", "#4a3aa7", "#e34948"];
export const SERIES_DARK = ["#3987e5", "#d95926", "#199e70", "#c98500", "#d55181", "#008300", "#9085e9", "#e66767"];
export const MAX_SERIES = SERIES_LIGHT.length;

export function isDark(): boolean {
  const forced = document.documentElement.dataset.theme;
  if (forced) return forced === "dark";
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

export function seriesColor(slot: number): string {
  return (isDark() ? SERIES_DARK : SERIES_LIGHT)[slot % MAX_SERIES]!;
}

/** Cor de um token do tema (index.css), para desenhar eixos e grade no canvas. */
export function token(name: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}
